const SearchIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <circle cx="11" cy="11" r="6.5" />
    <path d="m20 20-4.35-4.35" />
  </svg>
);

export default SearchIcon;
